import * as insuranceApi from '@/network/api/insurance.api.js'

/** Get Policies List
@return { promise }
*/
export const requestPoliciesList = async (context, payload) => {
	const res = await insuranceApi.getPoliciesList(payload)

	if (res) context.commit('SAVE_POLICIES_LIST', res.data.data)
	return res
}

/** Get Policy Details
@return { promise }
*/
export const requestPolicyDetails = async (context, payload) => {
	const res = await insuranceApi.getPolicyDetails(payload)

	return res
}

/** Get Policy Receipts List
@return { promise }
*/
export const requestPolicyReceiptsList = async (context, payload) => {
	const res = await insuranceApi.getPolicyReceiptsList(payload)

	if (res) context.commit('SAVE_POLICY_RECEIPTS_LIST', res.data.data)

	return res
}

/** Get Receipt Detail
@return { promise }
*/
export const requestReceiptDetail = async (context, payload) => {
	const res = await insuranceApi.getPolicyReceiptDetail(payload)

	return res
}

/** Get Receipt Documents List
@return { promise }
*/
export const requestPolicyReceiptDocumentsList = async (context, payload) => {
	const res = await insuranceApi.getPolicyReceiptDocumentsList(payload)

	return res
}
/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
	context.commit('CLEAR_FEATURE_STATE')
}
